/** Stage keys used by playbook list filters and `getPlaybookStage`. */
export type PlaybookStageId = 'early' | 'presence' | 'systems' | 'scale' | 'other';

export const PLAYBOOK_STAGE_FILTER_OPTIONS: { id: PlaybookStageId; label: string }[] = [
  { id: 'early', label: 'First users & outreach' },
  { id: 'presence', label: 'Audience & organic' },
  { id: 'systems', label: 'Email & funnels' },
  { id: 'scale', label: 'Scale & launch' },
];

export function getPlaybookStage(title: string): PlaybookStageId {
  const t = title.toLowerCase();

  if (
    t.includes('first 20') ||
    t.includes('get your first') ||
    t.includes('comments') ||
    t.includes('dms') ||
    t.includes('cold outreach')
  ) {
    return 'early';
  }

  if (t.includes('build in public') || t.includes('organic growth') || t.includes('blogs')) {
    return 'presence';
  }

  if (t.includes('lead magnet') || t.includes('email sequence') || t.includes('email')) {
    return 'systems';
  }

  if (
    t.includes('viral') ||
    t.includes('scaling') ||
    t.includes('partnership') ||
    t.includes('retention') ||
    t.includes('launch')
  ) {
    return 'scale';
  }

  return 'other';
}
